var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9113 0.487305C6.04653 0.487305 0.475098 6.05874 0.475098 12.9235C0.475098 19.7884 6.04653 25.3598 12.9113 25.3598C19.7761 25.3598 25.3476 19.7884 25.3476 12.9235C25.3476 6.05874 19.7761 0.487305 12.9113 0.487305ZM17.4008 8.37188C18.7315 8.37188 19.801 9.4414 19.801 10.7721C19.801 12.1028 18.7315 13.1723 17.4008 13.1723C16.0701 13.1723 15.0006 12.1028 15.0006 10.7721C14.9882 9.4414 16.0701 8.37188 17.4008 8.37188ZM9.93908 6.40696C11.5558 6.40696 12.874 7.7252 12.874 9.34191C12.874 10.9586 11.5558 12.2769 9.93908 12.2769C8.32237 12.2769 7.00413 10.9586 7.00413 9.34191C7.00413 7.71276 8.30993 6.40696 9.93908 6.40696ZM9.93908 17.7612V22.4248C6.95438 21.4921 4.59149 19.1914 3.54685 16.2565C4.85266 14.8636 8.11095 14.1547 9.93908 14.1547C10.5982 14.1547 11.4314 14.2542 12.302 14.4283C10.2624 15.5103 9.93908 16.9405 9.93908 17.7612ZM12.9113 22.8725C12.5756 22.8725 12.2522 22.8601 11.9289 22.8228V17.7612C11.9289 15.9953 15.5851 15.1123 17.4008 15.1123C18.7315 15.1123 21.0322 15.5973 22.1763 16.5425C20.7213 20.2361 17.1272 22.8725 12.9113 22.8725Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignee);
export default __webpack_public_path__ + "static/media/assignee.55810994e8da5f4a68955adad42932ed.svg";
export { ForwardRef as ReactComponent };